import React from 'react'
import { useDispatch } from 'react-redux'
import { AlertEmpty, Pagination } from '../../../components'
// import { useHistory, useLocation } from 'react-router-dom'
// import qs from 'query-string'

const PaginationAddOn = ({
  children,

  // Sorter Props
  data,

  // Pagination Nav Props
  itemsPerPage = 0,
  setPageItems,
  totalData = 0,

  // Pagination Nav Props - Redux
  setCurrentPage = () => {},
  defaultCurrentPage = 1,

  // Pagination API Props
  withPaginationAPI,

  pageIndexes,
  setPageIndexes
}) => {
  // const history = useHistory()
  // const location = useLocation()
  const dispatch = useDispatch()

  const handlePageItemsChange = React.useCallback(() => {
    if(data){
      if(withPaginationAPI){
        dispatch(setPageItems(data))
      } else {
        dispatch(setPageItems(data.slice(pageIndexes[0], pageIndexes[1])))
      }
      window.scrollTo(0, 0)
    }
  }, [dispatch, data, pageIndexes, setPageItems, withPaginationAPI])

  React.useEffect(() => {
    handlePageItemsChange()
    //eslint-disable-next-line
  }, [
    // Watch pagination: page changes
    pageIndexes,
    // Watch sorter: if root data changed (e.g sorting side effect)
    data
  ])

  const handlePageChange = (newPage) => {
    if(withPaginationAPI){
      // set to redux too
      setCurrentPage(newPage)

      // update pagination info (above the list)
      const calculatedEndIndex = itemsPerPage*newPage
      const endIndex = calculatedEndIndex > totalData ? totalData : calculatedEndIndex
      const startIndex = (itemsPerPage*newPage)-itemsPerPage
      setPageIndexes([startIndex, endIndex])

      /**
       * @todo
       * fix set 'page' query to URL.
       * current behaviour = duplicated fetching action
       */
      // // Set 'page' to URL query string
      // const currentQueryString = location.search
      // const currentQueryObject = qs.parse(currentQueryString)
      // const newQueryObject = {...currentQueryObject, page: newPage}
      // const newQueryString = '?'+qs.stringify(newQueryObject)

      // if(newQueryString !== currentQueryString){
      //   const currentPath = location.pathname
      //   history.replace({
      //     pathname: currentPath,
      //     search: newQueryString
      //   })
      // }
    } else {
      // Without Pagination API
      const startIndex = itemsPerPage*(newPage-1)
      const endIndex = startIndex+itemsPerPage
      setPageIndexes([startIndex, endIndex])
    }
  }

  return <>
    <div className="collection-list__pagination-add-on">
      {
        totalData > 0 ? (
          <>
            {children}
            <Pagination
              itemsPerPage={itemsPerPage}
              totalItems={totalData}
              onChange={handlePageChange}
              defaultCurrentPage={defaultCurrentPage}
            />
          </>
        ) : <AlertEmpty />
      }
    </div>
  </>
}

export { PaginationAddOn }
